import { InitializeVertex } from "./types";

export const initializeVertex: InitializeVertex = ({ graph, nodeId }): void => {
  if (!graph[nodeId]) {
    graph[nodeId] = [];
  }
};
